(function ($) {
    AOS.init({
        once: true,
        offset: 100,
        mirror: false,
        disableMutationObserver: false,
        // debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
        // throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
        // startEvent: 'load',
        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 400, // values from 0 to 3000, with step 50ms
        easing: 'ease-in-out-quart', // default easing for AOS animations
        anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
    });

    // $( window ).load(function() {
    //     AOS.refresh
    // });
})(jQuery);